import React, { useState } from 'react';
import { ChevronDown, LogOut, User, Settings } from 'lucide-react';
import { useAuth } from '../../hooks/useAuth';
import toast from 'react-hot-toast';

export function UserMenu() {
  const { currentUser, logout } = useAuth();
  const [isOpen, setIsOpen] = useState(false);

  const handleLogout = () => {
    try {
      logout();
      toast.success('Déconnexion réussie');
    } catch (error) {
      console.error('Logout error:', error);
      toast.error('Erreur lors de la déconnexion');
    }
  };

  const getInitials = () => {
    if (!currentUser?.email) return '?';
    return currentUser.email.substring(0, 2).toUpperCase();
  };

  const getDisplayName = () => {
    if (currentUser?.displayName) {
      return currentUser.displayName;
    }
    return currentUser?.email?.split('@')[0] || 'Utilisateur';
  };

  return (
    <div className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-2 text-sm focus:outline-none"
      >
        <div className="h-8 w-8 rounded-full bg-gradient-to-br from-[#2665EB] to-[#1b4bbd] flex items-center justify-center">
          <span className="text-white font-medium">{getInitials()}</span>
        </div>
        <div className="hidden md:block text-left">
          <div className="text-sm font-medium text-gray-900">
            {getDisplayName()}
          </div>
          <div className="text-xs text-gray-500">
            {currentUser?.email}
          </div>
        </div>
        <ChevronDown className="h-4 w-4 text-gray-500" />
      </button>

      {isOpen && (
        <div className="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-lg border border-gray-100 py-1">
          <button className="w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 flex items-center gap-2">
            <User className="h-4 w-4" />
            Mon profil
          </button>
          <button className="w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 flex items-center gap-2">
            <Settings className="h-4 w-4" />
            Paramètres
          </button>
          <div className="h-px bg-gray-100 my-1" />
          <button
            onClick={handleLogout}
            className="w-full px-4 py-2 text-sm text-red-600 hover:bg-red-50 flex items-center gap-2"
          >
            <LogOut className="h-4 w-4" />
            Déconnexion
          </button>
        </div>
      )}
    </div>
  );
}